import * as Swal from "sweetalert2";
<template>
  <div class="page height-full">
    <div class="container-fluid" v-if="isLoading">
      <strong><h4 style="margin-top: 25%" class="text-center">Linking Facebook account...</h4></strong>
      <spinner ></spinner>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import Constants from "../Constants";
  import Spinner from './common/Spinner'
  import * as Swal from "sweetalert2";

  export default {
    name: "FacebookOauth",
    components: {
      Spinner
    },
    data: () => {
      return {
        items: [],
        isLoading: false,
        form: {
          id: '',
          isEdit: false,
          name: '',
          keyword: '',
          postSignUpMessage: '',
          monthlyFrequency: 2
        },
        fields: ['name', 'keyword', 'postSignUpMessage', 'monthlyFrequency', 'subscriberCount', 'actions'],
        showDialog: false,
        items: [
          { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
          { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
          { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
          { age: 38, first_name: 'Jami', last_name: 'Carney' }
        ]
      }
    },
    methods: {
      getLists() {
        this.isLoading = true
        axios
          .get(Constants.API_URL + "/lists")
          .then(response => {
            this.isLoading = false
            console.log(response);
            (this.items = response.data.Items)
          }).catch(() => {
            if (err.response.status == 401) {
              window.location.href = "/lists"
            }
          }).then(() => {
            this.isLoading = false
          })
      },
      getToken() {
        this.isLoading = true
        console.log(this.$route)
        const id = this.$route.params.id
        const code = this.$route.query.code
        axios.get(Constants.API_URL + "/accounts/" + id + "/oauth/facebook?code=" + code)
          .then(response => {
            console.log(response)
            this.$router.push('/admin/' + id + '/users')
          }).catch((err) => {
            console.error(err)
          }).then(() => {
            this.isLoading = false
          })
      }
    },
    mounted() {
      this.getToken()
    }
  }
</script>

<style scoped>
  .dialog-content {
    width: 100%;
    padding-right: 60px;
    padding-left: 60px;
  }

  .md-dialog-container {
    width: 50%;
  }

  .delete {
    color: red;
  }

  .delete svg {
    margin-right: 8px;
    color: red;
  }

  .delete span {
    color: red;
  }

  .edit svg {
    margin-right: 8px;
  }

  .action-container {
    margin-top: -10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FacebookOauth.vue